import { clsx } from "clsx";
import type { z } from "zod/v4";
import { Text } from "@/components/Text";
import type { NextStepCardSchema } from "@/schemas/sections";
import { NextStepCardLink } from "./NextStepCardLink";

/** The `cards` layout: the tone-coloured upsell grid under a centred heading.
 *  The default, and what the material variant and `/l/check-your-inbox` keep —
 *  `NextStepsList` is the webinar variant's flat alternative. */
export function NextStepsCards({
  heading,
  subheading,
  cards,
}: {
  heading: string;
  subheading?: string;
  cards: z.input<typeof NextStepCardSchema>[];
}) {
  if (cards.length === 0) return null;

  return (
    <div data-component="NextStepsCards" className="mt-6 md:mt-8">
      <div className="mb-4 text-center">
        <Text variant="subheading" as="h2" className="text-fg">
          {heading}
        </Text>
        {subheading && (
          <Text variant="body-sm" as="p" className="mx-auto mt-1 max-w-lg text-muted">
            {subheading}
          </Text>
        )}
      </div>
      <div className={clsx("grid gap-3", cards.length >= 3 ? "md:grid-cols-3" : "md:grid-cols-2")}>
        {cards.map((card, index) => (
          <NextStepCardLink key={`${card.kind}:${card.href}`} card={card} index={index} />
        ))}
      </div>
    </div>
  );
}

NextStepsCards.displayName = "NextStepsCards";
